// Álbum: todas as fotos e vídeos de uma ficha (a viagem inteira, com roteiro, lugares e reservas) num lugar só.
// Em grupo, cada um põe as suas fotos e todos veem (os arquivos vão para a pasta do grupo).
import { Alert, Image, Pressable, Text, View } from 'react-native';
import type { Anexo, Reg } from '../store/types';
import type { PainelProps } from '../modulos/tipos';
import { abrirQualquer, fonteImagem, useUrlsGrupo } from './Anexos';
import { C } from './theme';
import { semBloqueio } from '../auth/AuthContext';
import { t } from '../lib/i18n';

const ehMidia = (a: Anexo) => !!a.mime && (a.mime.startsWith('image/') || a.mime.startsWith('video/'));

/** Fotos e vídeos da ficha e de tudo o que está dentro dela, dos mais novos para os mais antigos. */
export function midiasDe(regs: Reg[], raiz: string) {
  const dentro = new Set<string>([raiz]);
  const fila = [raiz];
  while (fila.length) { const p = fila.shift()!; for (const r of regs) if (r.pai === p && !dentro.has(r.id)) { dentro.add(r.id); fila.push(r.id); } }
  return regs.filter(r => dentro.has(r.id)).sort((a, b) => b.criado.localeCompare(a.criado))
    .flatMap(r => (r.anexos ?? []).filter(ehMidia).map(a => ({ a, r })));
}

export function PainelAlbum({ ctx, pai, novo }: PainelProps) {
  useUrlsGrupo();
  if (!pai) return null;
  const todas = midiasDe(ctx.regs, pai.id);
  const abrir = (a: Anexo) => semBloqueio(() => abrirQualquer(a)).catch(e => Alert.alert(t('Não foi possível'), String(e?.message ?? e)));
  return (
    <View style={{ gap: 8 }}>
      <Pressable onPress={() => novo()} style={{ backgroundColor: ctx.cor, borderRadius: 12, padding: 12, alignItems: 'center' }}>
        <Text style={{ color: '#fff', fontWeight: '800' }}>📷 {t('Adicionar fotos e vídeos')}</Text>
      </Pressable>
      <Text style={{ color: C.sub, fontSize: 12 }}>{todas.length
        ? t('{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.', { n: todas.length })
        : t('Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.')}</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 4 }}>
        {todas.slice(0, 120).map(({ a, r }, i) => {
          const uri = a.mime?.startsWith('image/') ? fonteImagem(a) : undefined;
          return (
            <Pressable key={r.id + i} onPress={() => abrir(a)} style={{ width: '32.4%', aspectRatio: 1, borderRadius: 8, overflow: 'hidden', backgroundColor: C.card2, alignItems: 'center', justifyContent: 'center' }}>
              {uri ? <Image source={{ uri }} style={{ width: '100%', height: '100%' }} resizeMode="cover" />
                : <Text style={{ fontSize: 28 }}>{a.mime?.startsWith('video/') ? '▶️' : '🖼️'}</Text>}
              {!!r.por && <Text style={{ position: 'absolute', left: 4, bottom: 3, color: '#fff', fontSize: 10, textShadowColor: '#000', textShadowRadius: 3 }} numberOfLines={1}>{r.por}</Text>}
            </Pressable>
          );
        })}
      </View>
      {todas.length > 120 && <Text style={{ color: C.mute, fontSize: 11 }}>{t('Mostrando as 120 mais recentes.')}</Text>}
    </View>
  );
}
